export const eventDeactivationState = {
  DEACTIVATED: 'DEACTIVATED',
  ACTIVATED: 'ACTIVATED',
  ELEDIO_ONLY: 'ELEDIO_ONLY',
}
